import React from 'react';
import './sevirity.scss';

interface SeverityProps {
    severityId: string | undefined;
}

export const Severity: React.FC<SeverityProps> = ({ severityId }) => {

    const severityValue = severityId === 'informational' ? 'Info' : severityId;

    return (
        <div className="severity">
            <div className={`severity-circle severity-${severityValue?.toLowerCase()}`} />
            <div className="severity-text">{severityValue}</div>
        </div>
    );
};